import { createReducer, on } from '@ngrx/store';
import { initialState } from './listings-selector';
import {
  getAllAmenities,
  getAllAmenitiesFailure,
  getAllAmenitiesSuccess,
  getAllPropertyTypes,
  getAllPropertyTypesFailure,
  getAllPropertyTypesSuccess,
  getBookingsFailure,
  getBookingsSuccess,
  getHomePageListings,
  getHomePageListingsFailure,
  getHomePageListingsSuccess,
  getPropertyDetails,
  getPropertyDetailsFailure,
  getPropertyDetailsSuccess,
  setPropertyStatus,
  setPropertyStatusFailure,
  setPropertyStatusSuccess,
  uploadFile,
  uploadFileFailure,
  uploadFileSuccess,
} from './listings-actions';
import { Property } from './listings.models';

const reducer = createReducer(
  initialState,
  on(
    getHomePageListings,
    getAllAmenities,
    getAllPropertyTypes,
    getPropertyDetails,
    setPropertyStatus,
    uploadFile,
    (state) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(setPropertyStatusSuccess, uploadFileSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
  })),

  on(getHomePageListingsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    list: data.result as Property[],
  })),

  on(
    getHomePageListingsFailure,
    getAllAmenitiesFailure,
    getAllPropertyTypesFailure,
    getPropertyDetailsFailure,
    setPropertyStatusFailure,
    uploadFileFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error,
    }),
  ),

  on(getAllAmenitiesSuccess, (state, { amenities }) => ({
    ...state,
    isLoading: false,
    amenities: amenities,
  })),

  on(getAllPropertyTypesSuccess, (state, { propertyTypes }) => ({
    ...state,
    isLoading: false,
    propertyTypes: propertyTypes,
  })),

  on(getPropertyDetailsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    detail: data.result,
  })),

  on(getBookingsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    bookings: data.result,
  })),

  on(getBookingsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
    bookings: [],
  })),
);

export function listingsReducer(state = initialState, action: any) {
  return reducer(state, action);
}
